import React from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper,
} from "@mui/material";
import { FundTransferDetails } from "../../interfaces/DTO/mislaka_xml_models";
import { formatContributionType, formatDepositorType, formatDepositTypeCode } from "../../utils/enumFormatter";
import { formatCurrency, formatHandlerCode } from "../../utils/namesFormater";

// פרופס לקומפוננטה
interface FundTransferHistoryProps {
  deposits: FundTransferDetails[];
}

const FundTransferHistory: React.FC<FundTransferHistoryProps> = ({
  deposits,
}) => {
  // חישוב הסכום הכולל
  const totalDepositsSum = deposits.reduce(
    (sum, deposit) => sum + deposit.deposit_amount_paid,
    0
  );

  // אם הרשימה ריקה, לא להציג כלום
  if (deposits.length === 0) {
    return null;
  }

  return (
    <Box sx={{ padding: 1 }}>
      {/* כותרת */}
      <Typography variant="h5" gutterBottom>
       ניוד נכנס
      </Typography>

      {/* סכום כולל */}
      <Typography variant="h6" gutterBottom>
        התקבלו: {formatCurrency(totalDepositsSum)}
      </Typography>
      {/* שורות מידע */}
      {deposits.map((deposit, index) => (
        <Typography key={index} variant="body1" sx={{ marginBottom: 1 }}>
          הועברו {formatCurrency(deposit.deposit_amount_paid)} מ{" "}
          {deposit.transferring_fund_name} בתאריך {deposit.fixing_date} (
          {formatContributionType(deposit.contribution_type)})
        </Typography>
      ))}
      {/* טבלה */}
      <TableContainer component={Paper} sx={{ marginTop: 2 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>תאריך הפקדה</TableCell>
              <TableCell>קוד סוג הפקדה</TableCell>
              <TableCell>סוג הפרשה</TableCell>
              <TableCell>סוג מפקיד</TableCell>
              <TableCell>סכום הפקדה</TableCell>
              <TableCell>בסיס שכר</TableCell>
              <TableCell>חודש שכר</TableCell>
              <TableCell>תקופת תשלום</TableCell>
              <TableCell>קוד תקופת תשלום</TableCell>
              <TableCell>מזהה מסלול מעביר</TableCell>
              <TableCell>מזהה קופה מעבירה</TableCell>
              <TableCell>שם קופה מעבירה</TableCell>
              <TableCell>תאריך קובע</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {deposits.map((deposit, index) => (
              <TableRow key={index}>
                <TableCell>{deposit.deposit_date}</TableCell>
                <TableCell>{formatDepositTypeCode(deposit.deposit_type_code)}</TableCell>
                <TableCell>{formatContributionType(deposit.contribution_type)}</TableCell>
                <TableCell>{formatDepositorType(deposit.depositor_type)}</TableCell>
                <TableCell>{deposit.deposit_amount_paid.toFixed(2)}</TableCell>
                <TableCell>{deposit.salary_base.toFixed(2)}</TableCell>
                <TableCell>{deposit.salary_month}</TableCell>
                <TableCell>{deposit.payment_period}</TableCell>
                <TableCell>{deposit.payment_period_code}</TableCell>
                <TableCell>{deposit.transferring_fund_id}</TableCell>
                <TableCell>{formatHandlerCode(deposit.transferring_corporation)}</TableCell>
                <TableCell>{deposit.transferring_fund_name}</TableCell>
                <TableCell>{deposit.fixing_date}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default FundTransferHistory;
